module.exports = __webpack_public_path__ + "static/media/empty-folder.15a84045.svg";